(function () {
    const nav = document.querySelector('.c-nav');
    const toggle = nav?.querySelector('.c-nav__toggle');

    if (!nav || !toggle) {
        return;
    }

    toggle.addEventListener('click', function () {
        const isOpen = nav.classList.toggle('c-nav--mobile-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
})();
